import { useContext } from 'react';
import styles from './TrimMileage.module.scss';
import { TileKitContext } from '../TileKit/TileKit';

const TrimMileage = () => {
  const { vehicle } = useContext(TileKitContext);
  const trim = vehicle?.trim;
  const mileage = Number(vehicle?.mileage || 0).toLocaleString();

  if (!vehicle?.vehicleId) {
    return (
      <div className="pb-12">
        <div className={styles['skeleton-trim']} />
      </div>
    );
  }

  return (
    <div className={styles['trim-mileage']} data-qa="trim-mileage">
      <span>{trim}</span> • <span>{mileage} miles</span>
    </div>
  );
};

export default TrimMileage;
